import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MyComponent from "./components/MyComponent/MyComponent.js";
import Menu from "./components/Menu/Menu.js";
import Footer from "./components/Footer/Footer.js";
import "./components/Menu/Menu.css";
import './index.css'
import Home from "./pages/Home/Home.js";
import Cases from "./pages/Cases/Cases.js";
import UnderConstruction from "./pages/UnderConstruction/UnderConstruction.js";
import Animation from "./pages/Animation/Animation.js";
import Video from "./pages/Videos/videos.js";
import Form from "./pages/Form/Form.js";
import MediaGallery from "./pages/MediaGallery/MediaGallery.js";
import GalleryDescription from "./pages/GalleryDescription/GalleryDescription.js";
import SiteRefreshPreview from "./pages/SiteRefreshPreview/SiteRefreshPreview.js";
import VR from "./pages/VR/VR.js";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DevTools from "./components/Dev/DevTools.js";
import { DevModeProvider } from './contexts/DevModeContext';

const exampleMediaItems = [
  { id: 1, type: 'image', src: "/Rectangle 201.png", alt: "Image 1", thumbnail: "/Rectangle 201.png" },
  { id: 2, type: 'video', src: "https://cdnjs.cloudflare.com/ajax/libs/media-files-sample/big-buck-bunny_trailer.webm", poster: "/api/placeholder/800/600", thumbnail: "/api/placeholder/200/200" },
  { id: 3, type: 'image', src: "/api/placeholder/800/600", alt: "Image 3", thumbnail: "/api/placeholder/200/200" },
  { id: 4, type: 'video', src: "https://cdnjs.cloudflare.com/ajax/libs/media-files-sample/Sintel.mp4", poster: "/api/placeholder/800/600", thumbnail: "/api/placeholder/200/200" },
  { id: 5, type: 'model', src: "/Heroi_comemora.glb", alt: "3D Model", thumbnail: "/Rectangle 201.png", title: "3D Model", title2: "Interactive Model" }
];
{/* GALLERY CONTENT */}
{/* Animation */}
const KoloshMedia = [
  
  { id: 1, type: 'video',title:"Kolosh",title2:"Kolosh video", src: "/Kolosh/Kolosh.mp4", poster: "/api/placeholder/800/600", thumbnail: "/Kolosh/Kolosh_Video_min.jpg" },
  { id: 2, type: 'image',title:"Kolosh",title2:"", src: "/Kolosh/Kolosh_Making_OFF_1.jpg", alt: "Image 1", thumbnail: "/Kolosh/Kolosh_Making_OFF_1.jpg" },
  { id: 3, type: 'image',title:"Kolosh",title2:"", src: "/Kolosh/Kolosh_Making_OFF_2.jpg", alt: "Image 2", thumbnail: "/Kolosh/Kolosh_Making_OFF_2.jpg" },
];

const YouComMedia  = [
  
  { id: 1, type: 'video',title:"YouCom",title2:"", src: "/YouCom/HD_YouCom_2.mp4", poster: "/api/placeholder/800/600", thumbnail: "/YouCom/YouCom_miniatura.jpg" },
  { id: 2, type: 'image',title:"YouCom",title2:"", src: "/YouCom/You_com_MOFF.jpg", alt: "Image 1", thumbnail: "/YouCom/You_com_MOFF.jpg" },
  { id: 3, type: 'image',title:"YouCom",title2:"", src: "/YouCom/YouCom_M_OFF_2.jpg", alt: "Image 2", thumbnail: "/YouCom/YouCom_M_OFF_2.jpg" },
  { id: 4, type: 'model',title:"YouCom",title2:"3D Model", src: "/Heroi_comemora.glb", alt: "3D Model", thumbnail: "/YouCom/YouCom_miniatura.jpg", cameraPosition: [-0.72,2.15,4.63], cameraFov: 50 }
];

const NaturaMedia  = [
  
  { id: 1, type: 'video',title:"Natura",title2:"", src: "/Natura/Natura_2.mp4", poster: "/api/placeholder/800/600", thumbnail: "/Natura/Miniatura_Natura.jpg" },
  { id: 2, type: 'video',title:"Natura",title2:"", src: "/Natura/Versão_orquidea.mp4", poster: "/api/placeholder/800/600", thumbnail: "/Natura/Miniatura_Natura.jpg" },
  { id: 3, type: 'image',title:"Natura",title2:"", src: "/Natura/Naura_Making_OFF.png", alt: "Image 2", thumbnail: "/Natura/Naura_Making_OFF.png" },
];


{/* GALLERY DESCRIPTIONS */}
const AnimationThumbnails =[
  { id:1, thumbnail:'/Kolosh/Miniatura.jpg', gallery:'/Kolosh'},
  { id:2, thumbnail:'/YouCom/YouCom_miniatura.jpg', gallery:'/YouCom'},
  { id:3, thumbnail:'/Natura/Miniatura_Natura.jpg', gallery:'/Natura'},
  { id:4, thumbnail:'/1ed837cf8ac1013f419a1bae89c5a269.png', gallery:'/GalleryAnimation'},
  { id:5, thumbnail:'/248bb518a423dfef4731db832e52f8f1.png', gallery:'/GalleryAnimation'},
  { id:6, thumbnail:'/Rectangle 200_2.png', gallery:'/GalleryAnimation'}
];


const CorporateThumbnails =[
  '/Rectangle 200_2.png','/Rectangle 200_2.png'
];
const VRThumbnails =[
  '/Rectangle 200_2.png','/Rectangle 200_2.png'
];

// Add a new media items array for 3D models
const modelsMedia = [
  { id: 1, type: 'model', title: "Hero", title2: "3D Model", src: "/Heroi_comemora.glb", alt: "Hero 3D Model", thumbnail: "/Rectangle 201.png" },
  { id: 2, type: 'image', title: "Hero", title2: "Reference Image", src: "/Rectangle 201.png", alt: "Hero Reference", thumbnail: "/Rectangle 201.png" },
  { id: 3, type: 'model', title: "Celulares", title2: "3D Model", src: "/not_used/models/Celulares.glb", alt: "Celulares 3D Model", thumbnail: "/Rectangle 201.png" },
  { id: 4, type: 'model', title: "Celulares V8", title2: "3D Model", src: "/not_used/models/Celulares_8.glb", alt: "Celulares 8 3D Model", thumbnail: "/Rectangle 201.png" },
  { id: 5, type: 'model', title: "Untitled Model", title2: "3D Model", src: "/not_used/models/untitled.glb", alt: "Untitled 3D Model", thumbnail: "/Rectangle 201.png" }
];

// Check and list available models for testing
const check3DModels = () => {
  const modelFiles = [
    "/Heroi_comemora.glb",
    "/not_used/models/Celulares.glb",
    "/not_used/models/Celulares_6.glb",
    "/not_used/models/Celulares_7.glb",
    "/not_used/models/Celulares_8.glb",
    "/not_used/models/untitled.glb"
  ];
  
  console.log("Available 3D models for testing animations:", modelFiles);
  return modelFiles;
};

// Call the function to log available models
check3DModels();

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppRoutes() {
  const { pathname } = useLocation();
  const isV2Preview = pathname === '/v2';

  return (
    <>
      {!isV2Preview && <Menu />}
      {!isV2Preview && <div className="Menu-background desktop" />}
      <ScrollToTop />
      <Routes>
            <Route path="/" element={<SiteRefreshPreview />} />
            <Route path="/Cases" element={<Cases />} />
            <Route path="joornada/tos"></Route>
            <Route path="/UnderConstruction" element={<UnderConstruction />} />
            <Route path="/Videos" element={<Video />} />
            <Route path="/Form" element={<Form />} />
            <Route path="/v2" element={<SiteRefreshPreview />} />
            <Route path="/Animation" element={<GalleryDescription gallery={'/GalleryAnimation'} mediaItems={AnimationThumbnails} title={'Animações e Mídia Out of Home - OOH'} description={'Destaque sua marca onde ela realmente importa! Criamos animações impactantes e estratégias de mídia OOH (Out-of-Home) que capturam a atenção e conectam marcas com seu público de forma única. Combinando criatividade, tecnologia e storytelling, desenvolvemos conteúdos visuais dinâmicos, nossa missão é transformar espaços urbanos em palcos de comunicação inesquecíveis. '} />} />
            <Route path="/VR" element={<GalleryDescription gallery={'/GalleryAnimation'} mediaItems={VRThumbnails} title={'Jogos e Realidade Virtual'} description={'Unimos a paixão por games e inovação em forma de realidade virtual para criar experiências únicas e imersivas. Com foco  no desenvolvimento de jogos e soluções em VR, transformamos ideias em universos interativos que encantam, engajam e surpreendem. Seja para entretenimento, treinamentos corporativos ou projetos educativos, nossa equipe combina tecnologia de ponta, design criativo e narrativas envolventes.'} />} />
            <Route path="/Kolosh" element={<MediaGallery mediaItems={KoloshMedia} />} />
            <Route path="/YouCom" element={<MediaGallery mediaItems={YouComMedia} />} />
            <Route path="/Natura" element={<MediaGallery mediaItems={NaturaMedia} />} />
            <Route path="/Images" element={<MediaGallery mediaItems={exampleMediaItems} />} />
            <Route path="/3DModels" element={<MediaGallery mediaItems={modelsMedia} />} />
      </Routes>
      {!isV2Preview && <Footer />}
    </>
  );
}

function App() {
  return (
    <DevModeProvider>
      <BrowserRouter>
        <DevTools>
          <AppRoutes />
        </DevTools>
      </BrowserRouter>
    </DevModeProvider>
  );
}

export default App;
